import React, { useEffect, useRef, useState } from "react";
import AddMonitoringRequest from "./AddEducationMonitoring";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import EducationalMonitoringCollapse from "./EducationalMonitoringCollapse";
import { Col, ConfigProvider, Row } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { AppDispatch, RootState } from "../../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import {
  getGeneralEducationMonitoring,
  getSubjects,
  getAcademicYears,
} from "../../../../apis/actions/monitoring.actions";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
const MonitoringRequest = ({ selectedFilter, filterOrphans, state }: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const { TotalGeneralMonitorings } = useSelector(
    (state: RootState) => state?.monitoring
  );
  const { data: monitorings, loading } = useSelector(
    (state: RootState) => state?.monitoring.monitorings
  );
  const { data: subjects } = useSelector(
    (state: RootState) => state?.monitoring.subjects
  );
  const { data: academicYears } = useSelector(
    (state: RootState) => state?.monitoring.academicYears
  );
  useEffect(() => {
    dispatch(getBeneficiaryDetails());
    dispatch(getSubjects());
    dispatch(getAcademicYears());
  }, [dispatch]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
useEffect(() => {
    setCurrentPage(1);
  }, [selectedFilter, state]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getGeneralEducationMonitoring({
        limit: itemPerPage,
        page: currentPage,
        partner_id: selectedFilter,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, currentPage, selectedFilter, state]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row gutter={8} style={{ marginBottom: "3rem" }}>
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={24}
            xs={24}
            style={{ paddingTop: "0.5rem" }}
          >
            <PrimaryButton
              onClick={() => setIsModalVisible(true)}
              title="طلب متابعة تعليمية"
              className="takaful--add-request-btn"
            />
          </Col>
        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      // eslint-disable-next-line eqeqeq
      ) : monitorings?.length === 0 && (!selectedFilter && state.year == "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      ) : monitorings?.length === 0 && (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <EducationalMonitoringCollapse
              requests={monitorings}
            />
          </Row>
          <div className="takaful--pagination-container">
            {monitorings &&
              Math.ceil(TotalGeneralMonitorings) * itemPerPage >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalGeneralMonitorings) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}

      <AddMonitoringRequest
        beneficiary={filterOrphans}
        subjects={subjects}
        academicYears={academicYears}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
      />
    </>
  );
};

export default MonitoringRequest;
